<template>
	<errorContainer :error="error" :warning="warning">
		<b-col md="12">
			<h1 :class="[`${!$screen.sm ? 'main-page-title' : ''}`, , { 'is-pwa': $isPwa() }]">
				{{ FormMSG(1, 'Supplier Label List') }}
			</h1>
		</b-col>
		<transition name="slide">
			<b-card no-body>
				<b-card-body>
					<b-row class="mb-3">
						<b-col cols="9" class="my-1">
							<b-form-group
								:label="FormMSG(2, 'Filter')"
								label-cols="2"
								label-align-sm="left"
								label-size="sm"
								label-for="filterInput"
								class="mb-0"
								v-if="$screen.width >= 992"
							>
								<b-input-group size="sm">
									<b-form-input
										v-model="filter"
										type="search"
										id="filterInput"
										:placeholder="FormMSG(3, 'Type to search...')"
										autocomplete="off"
									></b-form-input>
									<b-input-group-append>
										<b-button :disabled="!filter" @click="filter = ''">
											<i class="fa fa-times" aria-hidden="true"></i>
										</b-button>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col cols="3">
							<div class="float-right">
								<b-button :block="!$screen.md" @click="newLabel" variant="success" size="md" class="btn btn-primary btn-md float-right">
									{{ FormMSG(4, 'New Label') }}
								</b-button>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="12" xl="12">
							<b-table
								responsive="sm"
								ref="filmCommissionTable"
								:selected-variant="selectedColor"
								:hover="hover"
								:select-mode="selectMode"
								:items="contacts"
								:fields="fields"
								:head-variant="hv"
								:empty-text="FormMSG(5, 'No supplier label found')"
								:current-page="currentPage"
								:filter="filter"
								:per-page="perPage"
								tbody-tr-class="p-0"
								selectable
								bordered
								small
								show-empty
							>
								<template v-slot:cell(edit)="data">
									<div class="d-flex justify-content-center">
										<b-button variant="none" size="sm" @click="editSupplier(data.item.id)" style="line-height: 16px">
											<component :is="getLucideIcon(ICONS.EDIT.name)" :color="ICONS.EDIT.color" :size="20" />
										</b-button>
									</div>
								</template>
								<template v-slot:cell(delete)="data">
									<div class="d-flex justify-content-center">
										<b-button variant="none" size="sm" style="line-height: 16px" @click="deleteSupplier(data.item.id)">
											<component :is="getLucideIcon(ICONS.TRASH.name)" :color="ICONS.TRASH.color" :size="20" />
										</b-button>
									</div>
								</template>
							</b-table>
						</b-col>
					</b-row>
				</b-card-body>
			</b-card>
		</transition>
	</errorContainer>
</template>
<script>
import languageMessages from '@/mixins/languageMessages';
import { addUpdateSupplierAttribute, getSupplierAttributes, delSupplierAttribute } from '@/cruds/supplier-attribute.crud';
import { isNil } from '@/shared/utils';
import globalMixin from '@/mixins/global.mixin';

export default {
	name: 'SupplierLabelList',
	mixins: [languageMessages, globalMixin],
	computed: {
		baseFields() {
			return [
				{
					key: 'name',
					label: this.FormMSG(6, 'Name'),
					sortable: true,
					class: 'text-center'
				},
				{
					key: 'description',
					label: this.FormMSG(7, 'Description'),
					sortable: true
				},
				{
					key: 'webSite',
					label: this.FormMSG(8, 'Web Site'),
					sortable: true,
					formatter: (v) => v
				},
				// {
				// 	key: 'greenLabel',
				// 	label: this.FormMSG(9, 'Green Label ?'),
				// 	sortable: false,
				// 	class: 'text-center',
				// },
				{
					key: 'edit',
					label: this.FormMSG(10, 'Edit'),
					sortable: false,
					formatter: (v) => v,
					class: 'text-center'
				},
				{
					key: 'delete',
					label: this.FormMSG(11, 'Remove'),
					sortable: false,
					formatter: (v) => v,
					class: 'text-center'
				}
			];
		},
		fields() {
			return this.baseFields;
		}
	},
	data() {
		return {
			filter: '',
			error: {},
			warning: '',
			hover: true,
			currentPage: 1,
			perPage: 0,
			selectMode: 'single',
			selectedColor: 'primary',
			hv: 'dark',
			contacts: []
		};
	},
	async created() {
		await this.reloadData();
	},
	methods: {
		async newLabel() {
			await addUpdateSupplierAttribute({
				attributeType: 0
			}).then((record) => {
				if (record) {
					const path = `/supplier-label/n/${record.id}`;
					this.$router.push({ path });
				}
			});
		},
		editSupplier(id) {
			const path = `/supplier-label/u/${id}`;
			this.$router.push({ path });
		},
		deleteSupplier(id) {
			this.$bvModal
				.msgBoxConfirm(this.FormMSG(12, 'Are you sure to remove this supplier label ?'), {
					title: this.FormMSG(13, 'Confirm'),
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: this.FormMSG(14, 'YES'),
					cancelTitle: this.FormMSG(15, 'NO'),
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: false,
					noCloseOnBackdrop: true
				})
				.then(async (v) => {
					if (v) {
						await delSupplierAttribute(id).then(async (result) => {
							if (result) {
								await this.reloadData();
							}
						});
					}
				})
				.catch((err) => console.log(err));
		},
		async reloadData() {
			this.contacts = await getSupplierAttributes(0);
		}
	},
	watch: {
		'$route.query': {
			async handler(n) {
				const { s, id } = n;

				if (!isNil(s)) {
					if (s === '0') {
						this.createToastForMobile(this.FormMSG(16, 'Success'), this.FormMSG(17, 'Supplier label added successfully'), '');
					} else if (s === '1') {
						// delete
						await delSupplierAttribute(id).then((result) => {
							if (result) {
								this.createToastForMobile(this.FormMSG(18, 'Error'), this.FormMSG(19, 'Your data was not saved correctly'), '', 'danger');
							}
						});
					}
					this.$router.push('/supplier-label');

					await this.reloadData();
				}
			},
			deep: true,
			immediate: true
		}
	}
};
</script>
